import React from "react"
import {ActiveUnderline} from "../../components"
import {SnailItemActiveIndicatorProps} from "../props"

export const ClubSnailItemActiveIndicator = ({isActive}: SnailItemActiveIndicatorProps) => {
    return <ActiveUnderline isActive={isActive} height={0.25} />
}

export default ClubSnailItemActiveIndicator
